import React, { useState } from 'react'
import './landing.css'
import Container from 'react-bootstrap/Container'
import Video from '../components/video/video'
import ParallaxSafe from '../components/ParallaxSafe/parallaxsafe'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Seo from '../components/seo'
import Footer from "../components/footer/Footer"
import usePageInit from '../hooks/usePageInit'
import Pagination from '../components/pagination/pagination'
import './project.css'

const convertArrayToObject = (array, key) => {
    const initialValue = {}
    return array.reduce((obj, item) => {
        return {
            ...obj,
            [item[key]]: item.state,
        };
    }, initialValue)
};


const ProjectTemplate = (props) => {


    const isSSR = typeof window === "undefined"
    usePageInit()
    const [clicked, setClicked] = useState(convertArrayToObject(props?.context?.works?.worksRepeater?.map((_, i) => {
        return {
            key: i,
            state: false
        }
    }), 'key') || [])





    const clickHandler = (i) => {

        setClicked({
            ...clicked,
            ...{ [i]: true }
        })
    }



    return (
        <>
            <Seo seo={props.context?.seo}></Seo>
            <div className="project-layout" style={{ color: props.context.work?.textColor, backgroundColor: props.context.work?.backgroundColor }}>
                {props.context.work.videoHeader ?
                    <Container className="project-video">
                        {!isSSR &&
                            <Video videoId={props.context.work?.videoHeader} controls={true} muted={false} />
                        }
                    </Container>
                    :
                    <Container className="project-image">
                        <img src={props.context?.featuredImage?.node?.sourceUrl} alt={props.context?.featuredImage?.node?.altText} />
                    </Container>
                }
                <Container className="project-content">
                    <Row>
                        <Col xs={12} md={6}>
                            <h2 dangerouslySetInnerHTML={{ __html: props.context.work?.headlineText }} />
                        </Col>
                        <Col xs={12} md={6}>
                            <div dangerouslySetInnerHTML={{ __html: props.context?.content }} />
                        </Col>
                    </Row>
                </Container>
                <Container fluid className="fluid-no-padding images-work" >

                    <Row>
                        {
                            props.context.works.worksRepeater.map((item, i) => {

                                return item.breite != null ?
                                    item.videoId != null ?
                                        <a style={i % 4 === 3 ? { justifyContent: 'flex-end', zIndex: item?.zindex, left: item?.xaxis } : { zIndex: item?.zindex, left: item?.xaxis }} href={item.link?.url} target={item.link?.target} key={i} className={`col-12 col-md-3 small-100 work-col ${item.hidemobile === true ? 'display-mobile-none' : ''}`} >
                                            {!isSSR &&
                                                <ParallaxSafe yto={item?.yto} yfrom={item?.yfrom} >
                                                    {({ imageLoad }) => (
                                                        <Video width={item?.breite} videoId={item.videoId} onLoad={imageLoad} controls={true} muted={true} />
                                                    )}
                                                </ParallaxSafe>
                                            }
                                        </a>
                                        :
                                        item.text != null ?
                                            <div className={`col-12 col-md-3 small-100 work-col ${item.hidemobile === true ? 'display-mobile-none' : ''}`} key={i} style={i % 4 === 3 ? { justifyContent: 'flex-end', zIndex: item?.zindex, left: item?.xaxis } : { zIndex: item?.zindex, left: item?.xaxis }} >
                                                {!isSSR &&
                                                    <ParallaxSafe yto={item?.yto} yfrom={item?.yfrom} >
                                                        {({ imageLoad }) => (
                                                            <div style={{ width: `${item?.breite}%` }} dangerouslySetInnerHTML={{ __html: item.text }} onLoad={imageLoad} />
                                                        )}
                                                    </ParallaxSafe>
                                                }
                                            </div>
                                            :
                                            <a href={item.externalLink?.url} style={i % 4 === 3 ? { justifyContent: 'flex-end', zIndex: item?.zindex, left: item?.xaxis } : { zIndex: item?.zindex, left: item?.xaxis }} target={item.externalLink?.target} key={i} className={`col-12 col-md-3 small-100 work-col ${item.hidemobile === true ? 'display-mobile-none' : ''}`} >
                                                {!isSSR &&
                                                    <ParallaxSafe yto={item?.yto} yfrom={item?.yfrom} >
                                                        {({ imageLoad }) => (
                                                            <>

                                                                <img onClick={() => clickHandler(i)} className="floating-img" srcSet={item.image?.scrSet} src={item.image?.sourceUrl} alt={item.image?.altText} style={i % 4 === 3 ? { justifyContent: 'flex-end', zIndex: item?.zindex, left: item?.xaxis, textAlign: 'right', width: `${item?.breite}%` } : { zIndex: item?.zindex, left: item?.xaxis, width: `${item?.breite}%` }} onLoad={imageLoad} />

                                                                {item.soundFile?.mediaItemUrl &&
                                                                    clicked[i] &&
                                                                    <audio
                                                                        controls
                                                                        autoPlay
                                                                        src={item.soundFile?.mediaItemUrl}>
                                                                        Your browser does not support the
                                                                        <code>audio</code> element.
                                                                    </audio>
                                                                }
                                                            </>
                                                        )}
                                                    </ParallaxSafe>
                                                }
                                            </a>
                                    :

                                    <div key={i} className={`col-12 col-md-3 small-100 work-col no-padding ${item.hidemobile === true ? 'display-mobile-none' : ''}`} style={i % 4 === 3 ? { justifyContent: 'flex-end', zIndex: item?.zindex, left: item?.xaxis } : { zIndex: item?.zindex, left: item?.xaxis }}>
                                    </div>
                            })}
                    </Row>

                </Container>
                {props.lang === 'de' ?
                    <Pagination nextSlug={props?.nextSlug} prevSlug={props?.prevSlug} nextText="NächsTeS ProJekT" prevText="Voriges Projekt" color={props.context.work?.textColor} rootSlug="projekt"  ></Pagination>
                    :
                    <Pagination nextSlug={props?.nextSlug} prevSlug={props?.prevSlug} nextText="NächsTeS ProJekT" prevText="Voriges Projekt" color={props.context.work?.textColor} rootSlug="en/projekt"  ></Pagination>
                }
            </div>
            < Footer ></Footer>

        </>
    )
}

export default ProjectTemplate
